import { createContext, useContext, type ReactNode } from "react";

export type EhrRecordsPushedScreen = {
  title: string;
  content: ReactNode;
};

type EhrRecordsScreenContextValue = {
  pushScreen: (screen: EhrRecordsPushedScreen) => void;
  popScreen: () => void;
};

const EhrRecordsScreenContext = createContext<EhrRecordsScreenContextValue | null>(
  null,
);

/** Empilha telas dentro do ScreenMobile do sumário (mesmo header do app). */
export function EhrRecordsScreenProvider({
  pushScreen,
  popScreen,
  children,
}: EhrRecordsScreenContextValue & { children: ReactNode }) {
  return (
    <EhrRecordsScreenContext.Provider value={{ pushScreen, popScreen }}>
      {children}
    </EhrRecordsScreenContext.Provider>
  );
}

export function useEhrRecordsScreen(): EhrRecordsScreenContextValue {
  const context = useContext(EhrRecordsScreenContext);
  if (!context) {
    throw new Error("useEhrRecordsScreen must be used within EhrRecordsScreenProvider");
  }
  return context;
}

/** Retorna null fora do sumário mobile empilhável. */
export function useEhrRecordsScreenOptional(): EhrRecordsScreenContextValue | null {
  return useContext(EhrRecordsScreenContext);
}
